// Types for Indexing Dashboard

export type IndexStatus = {
    index_name: string;
    tipo_documento: string;
    nombre_documento?: string;
    listo_para_indexar: number;
    corrompido: number;
    en_cola: number;
    indexado: number;
    falta_ocr: number;
    pdf_validado: number;
    no_descargado: number;
};

export const STATUS_FIELDS = [
    { key: 'listo_para_indexar', label: 'Listo para indexar' },
    { key: 'corrompido', label: 'Corrupto' },
    { key: 'en_cola', label: 'En cola' },
    { key: 'indexado', label: 'Indexado' },
    { key: 'falta_ocr', label: 'Falta OCR' },
    { key: 'pdf_validado', label: 'PDF validado' },
    { key: 'no_descargado', label: 'No descargado' }
] as const;

export type StatusKey = typeof STATUS_FIELDS[number]['key'];

export type DocumentStatusMatrixRow = {
    tipo_documento: string;
    id?: string;
    children?: DocumentStatusMatrixRow[];
} & Record<StatusKey, number>;

export type DetailStatusRow = {
    index_name: string;
    tipo_documento: string;
    total_documentos: number;
    indexado: number;
    corrompido: number;
    falta_ocr: number;
    pdf_validado: number;
};

export type RecentlyIndexedRow = {
    name: string;
    count: number;
};

export const DETAIL_STATUS_FIELDS = [
    { key: 'pdf_validado', label: 'PDF validado' },
    { key: 'indexado', label: 'Indexado' },
    { key: 'corrompido', label: 'Corrompido' },
    { key: 'falta_ocr', label: 'Falta OCR' }
] as const;

export type DetailStatusKey = typeof DETAIL_STATUS_FIELDS[number]['key'];

export type FilterOption = {
    label: string;
    value: string;
};

export type FilterConfig = {
    label: string;
    options: FilterOption[];
    selectedValues: string[];
    multiSelect?: boolean;
};

export type ThemeColors = {
    background: string;
    cardBackground: string;
    cardBorder: string;
    text: string;
    textSecondary: string;
    buttonText: string;
    buttonBackground: string;
    buttonHover: string;
    buttonActiveBg: string;
    buttonActiveText: string;
    purple: string;
    purpleDark: string;
    purpleLight: string;
    border: string;
    borderLight: string;
    gridLine: string;
    dropdownBg: string;
    dropdownBorder: string;
    dropdownHover: string;
    dropdownSelected: string;
};

export type WidgetCardProps = {
    title: string;
    value: string | number;
    icon?: string;
    subtitle?: string;
    size?: 'sm' | 'md' | 'lg';
    themeColors: ThemeColors;
};

export type DropdownFilterProps = {
    filters: FilterConfig[];
    onFilterChange: (filterLabel: string, selectedValues: string[]) => void;
    themeColors: ThemeColors;
};
